module.exports = __webpack_public_path__ + "static/media/logo-hub-branco.e76dbeeb.png";